export default __webpack_public_path__ + "static/media/ltp_hilo_percent.9aae594a.png";